import Storage from "good-storage";
import { Toast } from "vant";
import { isLogin } from "@/utils/common.js";
import { myReferralCode, referralVisit, referralBind } from "@/api/nrc.js";

const VISITS_KEY = "NRC_REFERRAL_VISITS";

function visits() {
  return (Storage.get(VISITS_KEY) || []).filter((v) => new Date(v.expireTime).getTime() > Date.now());
}

function saveVisit(visit) {
  let list = visits().filter((v) => !(v.targetType === visit.targetType && String(v.targetId) === String(visit.targetId)));
  list.push(visit);
  Storage.set(VISITS_KEY, list.slice(-20));
}

export function captureReferralVisit(targetType, targetId, referralCode) {
  if (!referralCode) return Promise.resolve(null);
  return referralVisit({ targetType, targetId, referralCode })
    .then((visit) => {
      saveVisit(visit);
      if (isLogin()) return referralBind({ visitToken: visit.visitToken }).then(() => visit);
      return visit;
    })
    .catch(() => null);
}

export function bindLatestReferral() {
  if (!isLogin()) return Promise.resolve(false);
  let list = visits();
  let latest = list[list.length - 1];
  return latest ? referralBind({ visitToken: latest.visitToken }).catch(() => false) : Promise.resolve(false);
}

export function orderReferralToken(expertId, directionId) {
  let matched = visits().filter((v) =>
    (v.targetType === 1 && String(v.targetId) === String(expertId)) ||
    (v.targetType === 2 && String(v.targetId) === String(directionId))
  );
  return matched.length ? matched[matched.length - 1].visitToken : undefined;
}

export function shareReferralPage(path, title) {
  return myReferralCode().then(({ referralCode }) => {
    let url = `${window.location.origin}${window.location.pathname}#${path}${path.includes("?") ? "&" : "?"}ref=${encodeURIComponent(referralCode)}`;
    if (navigator.share) {
      return navigator.share({ title, text: title, url }).catch((e) => {
        if (e && e.name === "AbortError") return;
        return copy(url);
      });
    }
    if (/MicroMessenger/i.test(navigator.userAgent)) {
      // 微信右上角只能转发当前地址；先把带推荐码的地址写回地址栏，再提示用户操作。
      window.history.replaceState({}, document.title, url);
      Toast({ message: "请点击右上角“…”转发给同事", duration: 3500 });
      return Promise.resolve();
    }
    return copy(url);
  });
}

function copy(text) {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    return navigator.clipboard.writeText(text).then(() => Toast.success("分享链接已复制"));
  }
  let input = document.createElement("textarea");
  input.value = text; document.body.appendChild(input); input.select(); document.execCommand("copy"); input.remove();
  Toast.success("分享链接已复制");
  return Promise.resolve();
}
